__turbopack_context__.v({
  "criteriaList": "styles-module__Se1uPG__criteriaList",
  "criterionItem": "styles-module__Se1uPG__criterionItem",
  "criterionText": "styles-module__Se1uPG__criterionText",
  "description": "styles-module__Se1uPG__description",
  "iconWrapper": "styles-module__Se1uPG__iconWrapper",
  "image": "styles-module__Se1uPG__image",
  "imageContainer": "styles-module__Se1uPG__imageContainer",
  "section": "styles-module__Se1uPG__section",
});
